import React, { ComponentState, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getPendingDoc, getSignedDoc, saveSignedDocResponse } from "../../../../../redux/actions"
import { DocumentRequestObj, MetaData, ResultDocumentData } from "../../../../../dataModel/documentModels"
import moment from "moment"
import { DocumentListComponent } from "./documentListComponent"

export const SignedDocList = () => {

  const state: ComponentState = useSelector(states => {
    return states;
  });

  const { signedDoc,saveSignedDocResp } = state['DocumentReducer'];
  const { loadingState } = state['LoaderReducer'];


  var now = moment(new Date()).format("YYYY-MM-DD");
  var previous = moment(new Date()).subtract(5, 'years').format("YYYY-MM-DD");
  const emptyObj: DocumentRequestObj = { startDate: previous, endDate: now, pageNumber: 1, pageSize: 10 }
  const [requestObj, setRequestObj] = useState<DocumentRequestObj>(emptyObj)
  const [signedDocList, setSignedDocList] = useState<ResultDocumentData[]>()
  const [metaObj, setMetaObj] = useState<MetaData>()
  const dispatch = useDispatch()
  const [isDataFetched, setIsDataFetched] = useState(false)

  useEffect(() => {
    if (!isDataFetched) {
      setIsDataFetched(true)
      dispatch(getSignedDoc(requestObj))
    }
  }, [isDataFetched])

  useEffect(() => {

    if (saveSignedDocResp && saveSignedDocResp.status) {
        dispatch(saveSignedDocResponse())
        setRequestObj({...requestObj,pageNumber:1})
        dispatch(getSignedDoc({...requestObj,pageNumber:1}))
    }
}, [saveSignedDocResp])


  useEffect(() => {
    if (signedDoc && signedDoc.resultData) {
      setSignedDocList(signedDoc.resultData)
      setMetaObj(signedDoc.metaData)
    }
  }, [signedDoc])

  function handleChangePage(event: any, newpage: any) {
    setRequestObj({ ...requestObj, pageNumber: (newpage + 1) })
    dispatch(getSignedDoc({ ...requestObj, pageNumber: (newpage + 1) }))
  }

  function handleChangeRowsPerPage(event: any) {
    setRequestObj({ ...requestObj, pageSize: parseInt(event.target.value, 10), pageNumber: 1 })
    dispatch(getSignedDoc({ ...requestObj, pageSize: parseInt(event.target.value, 10), pageNumber: 1 }))
  }


  

  return (  <DocumentListComponent
    tabSelecteionID="tabs-2"
    loadingState={loadingState}
    tabId={2}
    documentList={signedDocList? signedDocList:[]}
    handleChangePage={handleChangePage}
    handleChangeRowsPerPage={handleChangeRowsPerPage}
    metaObj={metaObj}
    requestObj={requestObj}
    ></DocumentListComponent>);
}